/**
 * ContractSlice State Definition
 * 
 * Defines the state interface and initial state for the contract slice.
 */

import { ContractView, FeeScheduleView } from '../types/contractTypes';

/**
 * State interface for the contract slice.
 */
export interface ContractSliceState {
  /** The current contract being viewed/edited, or null if none selected */
  currentContract: ContractView | null;
  /** The current fee schedule being viewed/edited, or null if none selected */
  currentFeeSchedule: FeeScheduleView | null;
  /** Whether the user is in edit mode */
  isEditing: boolean;
  /** Whether any edits have been made since loading/saving */
  isDirty: boolean;
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
  /** Whether the rule modal is open */
  ruleModalOpen: boolean;
  /** The currently selected rule ID, if any */
  selectedRuleId: string | null;
  /** The currently selected tab index */
  selectedContractTabIndex: number;
}

/**
 * Initial state for the contract slice.
 */
export const initialState: ContractSliceState = {
  currentContract: null,
  currentFeeSchedule: null,
  isEditing: false,
  isDirty: false,
  validationErrors: {},
  ruleModalOpen: false,
  selectedRuleId: null,
  selectedContractTabIndex: 0,
};
